/* eslint-disable */
import CAMApp from "./webparts/cam/components/CAMApp";
import { defaultConfigApi } from "./webparts/cam/api/base/defaultConfigApi";

const CAMAppComponent = () => {
  return <CAMApp apiConfig={defaultConfigApi} />;
};

export default CAMAppComponent;
